// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-a6d7f49c] .modal-dialog{max-width:665px !important}[data-v-a6d7f49c] .ag-cell-wrapper{display:block !important}[data-v-a6d7f49c] .ag-center-cols-clipper{min-height:unset !important}", ""]);
// Exports
module.exports = exports;
